import { render, staticRenderFns } from "./BloqueTexto.vue?vue&type=template&id=40268d9c"
import script from "./BloqueTexto.vue?vue&type=script&lang=js"
export * from "./BloqueTexto.vue?vue&type=script&lang=js"
import style0 from "./BloqueTexto.vue?vue&type=style&index=0&id=40268d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports